import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { AccessDirectory } from 'src/app/interfaces/access-directory';
import { AccessDirectories } from 'src/app/interfaces/access-diretories';
import { City } from 'src/app/interfaces/city';
import { Directory } from 'src/app/interfaces/directory';
import { DirectoryService } from 'src/app/services/api/directory.service';
import { LoadingService } from 'src/app/services/loading.service';
import { LocalisationService } from 'src/app/services/localisation.service';
import { SharedDirectoryToSendService } from 'src/app/services/shared/shared-directory-to-send.service';
import { UserService } from 'src/app/services/user.service';
import { PatientInfoModalComponent } from '../../modals/patient-info-modal/patient-info-modal.component';

@Component({
  selector: 'app-directory-form',
  templateUrl: './directory-form.component.html',
  styleUrls: ['./directory-form.component.scss'],
  providers: [DatePipe]
})
export class DirectoryFormComponent implements OnInit, OnDestroy {

    loading$ = this.loader.loading$;

    public errorMessage: string ;
    public errorType: string ;

    public searchForm: FormGroup | undefined;
    public directories: Directory[];

    signatories: string[] = [];

    @Output() signatoriesEvent = new EventEmitter<string[]>();

    cities: City[] = [];

    selectedCity: string = '';

    filteredOptions: Observable<City[]> | undefined;
    closeResult = '';

    maxDate = new Date();

    @Input() accessDirectory: AccessDirectories | undefined;

    directoryToSend: Directory[] = [];
    subscription: Subscription | undefined;

    constructor(public directoryApi: DirectoryService,
                private datePipe: DatePipe,
                public loader: LoadingService,
                public userService: UserService,
                private localisationService: LocalisationService,
                private sharedDirectoryToSendService: SharedDirectoryToSendService,
                private modalService: NgbModal,
                private router: Router)
    {
        this.errorMessage = "";
        this.errorType = "";
        this.directories = [];
    }

    ngOnInit(): void {
      const selectedDirectories = [
        ...this.accessDirectory!.ps.map(access => access.ps),
        ...this.accessDirectory!.clients.map(client => client.structure)
      ];

        this.searchForm = new FormGroup({
            lname: new FormControl(''),
            fname: new FormControl(''),
            email: new FormControl(''),
            phoneNumber: new FormControl(''),
            city: new FormControl(''),
            dateOfBirth: new FormControl(''),
            directory: new FormControl(selectedDirectories),
            ins: new FormControl('')
        });

        this.filteredOptions = this.searchForm.controls.city.valueChanges.pipe(
            startWith(''),
            debounceTime(500),
            distinctUntilChanged(),
            map((value) => value && value.length >= 1 ? this._filter(value) : [])
        );

        this.subscription = this.sharedDirectoryToSendService.sharedDirectory.subscribe((directories: Directory[]) => {
            this.directoryToSend = directories
        });
    }

    ngOnDestroy(): void {
        this.searchForm?.reset();
        this.subscription?.unsubscribe();
    }

    private _filter(value: string): City[] {
        this.cities = [];
        if (value.length >= 3) {
            const filterValue = value.toLowerCase();
            if (filterValue.match(/\d{5}/gm)) {
                if (filterValue == '98000') {
                    var monaco = <City>{};
                    monaco.nom = 'Monaco';
                    this.cities.push(monaco);
                    return this.cities;
                } else {
                    this.localisationService.getCitiesByPostalCode(filterValue).subscribe((res) => {
                        res.forEach((cityRes) => {
                            var city = <City>{};
                            city.nom = cityRes.nom;
                            this.cities.push(city);
                        });

                        return this.cities;
                    });
                }
            } else {
                if (filterValue.match(/monaco/gm)) {
                    var monaco = <City>{};
                    monaco.nom = 'Monaco';
                    this.cities.push(monaco);
                    return this.cities;
                } else {
                    this.localisationService.getCities(filterValue).subscribe((res) => {
                        res.forEach((cityRes) => {
                            var city = <City>{};
                            city.nom = cityRes.nom;
                            this.cities.push(city);
                        });
                        return this.cities;
                    });
                }
            }
        } else {
            this.cities = [];
        }
        return this.cities;
    }

    public search(searchForm: any)
    {
        let criteria = [];
        for (const [key, value] of Object.entries(searchForm)) {
            if (value !== '') {
                if (key === 'dateOfBirth') {
                    const date = this.datePipe.transform(searchForm.dateOfBirth, 'yyyy-MM-dd');
                    if (date) {
                        criteria.push(key + "=" + encodeURIComponent(date));
                    }
                } else {
                    criteria.push(key + "=" + value);
                }
            }
        }


        this.loader.show("SPINNER-LOADER.SEARCH");


        this.directoryApi.getPatients(criteria).subscribe((res) => {
            this.loader.hide();
            if (res.result == "SUCCESS") {
                this.directories = res.content;
            } else {
                this.errorMessage = res.content;
                this.errorType = res.result;
            }
        }, (resError) => {
            this.loader.hide();
        });
    }

    public open(content: any) {
        const modalRef = this.modalService.open(PatientInfoModalComponent, {size: 'lg', centered: true})
        modalRef.componentInstance.patientID = content.uuid;
        modalRef.result.then((data) => {
        }, (reason) => {
            if (reason) {
                const deleteRegex = "Delete (.*)";
                const addRegex = "Add (.*)";
                let email: string[];
                //On retire le patient de la liste
                if ((email = reason.match(deleteRegex)) !== null) {
                    //On retire le patient de la liste des patients retourné par la recherche.
                    //Lors de la prochaine recherche le patient ne sera plus visible vu qu'il a été retirer de la table directory
                    //filter() retourne une liste en fonction des critères passés (ici on ne veut plus le patient supprimé)
                    const res = this.directories.filter(patient => patient.user.email !== email[1]);
                    this.directories = res;
                } else if ((email = reason.match(addRegex)) !== null) {
                  const address = email[1];
                  if (!this.signatories.includes(address)) {
                    this.signatories.push(address);
                    this.signatoriesEvent.emit(this.signatories);
                  }
                }
            }
        });
    }

    addSignatories(patient: Directory) {
        if (!this.signatories.includes(patient.user.email)) {
            this.signatories.push(patient.user.email);
            const dest = { "email": patient.user.email, "directory": patient.uuid };
            this.sharedDirectoryToSendService.addDirectory(dest);
            this.signatoriesEvent.emit(this.signatories);
        }
    }

    removeSignatory(patientMail: string) {
        const index = this.signatories.indexOf(patientMail, 0);
        if (index > -1) {
            this.signatories.splice(index, 1);
            this.sharedDirectoryToSendService.removeDirectory(patientMail);
        }
        this.signatoriesEvent.emit(this.signatories);
    }

    reinitSignatories() {
        this.signatories = [];
        this.signatoriesEvent.emit(this.signatories);
        this.sharedDirectoryToSendService.resetDirectory();
    }

    toCreate() {
        if (this.router.url.match('\/create.*')) {
            this.modalService.dismissAll();
        } else {
            if (this.signatories) {
                this.router.navigate(['/create'], {
                    queryParams: {recipient: this.signatories.join(";")},
                });
            } else {
                this.errorMessage = 'ERRORS.SIGNATORY-REQUIRED';
                this.errorType = 'ERROR';
            }

        }
    }

    cityClick(event: any) {
        this.selectedCity = event.option.value;
    }

    checkCity() {
        setTimeout(()=> {
            if (!this.selectedCity || this.selectedCity !== this.searchForm?.controls['city'].value) {
                if (this.searchForm?.controls['city'].value.match(/\d{5}/gm)) {
                    this.searchForm?.controls['city'].setValue(null);
                    this.selectedCity = '';
                }
            }
        }, 500);
    }
}
